import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseService } from 'src/app/core/services/base.service';
import { PosStoreService } from '../../pos.store.service';
import { OiGroupDialogData, OiGroupProcessDialogComponent } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';
import { NotificationService } from '@optsolservices/ngx-notification';
import { HelperService } from 'src/app/core/services/helper.service';
import { Request } from '@optsolservices/ngx-data-table-with-search-criteria';

@Component({
  selector: 'app-sales-order-search-stock-code-dialog',
  templateUrl: './sales-order-search-stock-code-dialog.component.html',
  styleUrls: ['./sales-order-search-stock-code-dialog.component.scss']
})
export class SalesOrderSearchStockCodeDialogComponent implements OnInit {
  form: FormGroup;
  stockCodesTableConfigRequest: Request = null;
  stockCodesTableDataRequest: Request = null;
  stockCodesSearchCriteriaRequest: Request = null;
  selectedKeys: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<SalesOrderSearchStockCodeDialogComponent>,
    public fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private baseService: BaseService,
    private posStoreService: PosStoreService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private helperService: HelperService,
  ) { }

  ngOnInit() {
    this.stockCodesTableConfigRequest = {
      url: this.helperService.apiUrl('portal_sales_order_search_stock_codes_table_config'),
      resultField: 'data',
      body: {

      }
    };

    this.stockCodesSearchCriteriaRequest = {
      url: this.helperService.apiUrl('portal_sales_order_search_stock_codes_search_criteria'),
      resultField: 'data',
      body: {
        salesOrder: this.data
      }
    };

    this.stockCodesTableDataRequest = {
      url: this.helperService.apiUrl('portal_sales_order_search_stock_codes_table_content'),
      resultField: 'data',
      body: {
        salesOrder: this.data
      }
    };
  }

  actionButtonClicked(event: any): void {
    this.dialogRef.close({ stockCode: event?.data?.stockCode, qty: 1 });
  }


  // this.dialogRef.close()

  // this.baseService.executeCommand('portal_pr_procurement_details_add_existing_sub_comp_from_cost_to_cost', {
  //   procurementItemId: event.data.procurementItemId,
  //   topLevelComponentId: this.data.topLevelComponentId,
  //   procurementVersion: this.data.procurementVersion,
  // }).subscribe(response => {
  //   console.log('response', response);
  //   this.data.procurementVersion = (response.data as any).procurementVersion;
  // });
  // }

  // search() {
  //   if (this.data.mode === 'SYSPRO') {
  //     const dialogData: OiGroupDialogData = {
  //       title: 'Adding line to the order in SYSPRO',
  //       function: 'portal_oi_group_syspro_order_add_line',
  //       postBody: {
  //         salesOrderNumber: this.data.salesOrderNumber,
  //         stockCode: this.form.value.stockCode,
  //         qty: this.form.value.qty
  //       }
  //     };

  //     const ref = this.dialog.open(OiGroupProcessDialogComponent, {
  //       data: dialogData,
  //       width: '450px'
  //     });

  //     ref.afterClosed().subscribe(oiResult => {
  //       if (oiResult.responseCode === 0) {
  //         this.notificationService.success('Line Added');
  //       }
  //     });

  //   } else {
  //     this.baseService.executeCommand<any[]>('portal_sales_order_add_stock_code', {
  //       salesOrderHeaderId: this.data.salesOrderHeaderId,
  //       stockCode: this.form.value.stockCode,
  //       qty: this.form.value.qty
  //     })
  //       .subscribe(response => {
  //         if (response.responseCode === 0) {

  //           this.form.controls['stockCode'].reset();

  //           this.posStoreService.notifySalesOrderChanged({
  //             salesOrderHeaderId: this.data.salesOrderHeaderId,
  //             source: 'SalesOrderScanStockCodeDialogComponent'
  //           });
  //         }
  //       });
  //   }
  // }

}
